
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalCharging100 as ObiBatteryVerticalCharging100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-charging-100.js';
 
 
 

 
 export const ObiBatteryVerticalCharging100 = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-charging-100',
   elementClass: ObiBatteryVerticalCharging100Element,
   events: {
     
   }
  });
 
 